<template>
    <div class="white_bg">
        <div class="inner">

            <div class="white_bg" style="padding-bottom: 24px">
                <div class="flexLayout">
                    <div class="flexItem alignC" v-for="filterTypeItem in filterTypeList" :key="filterTypeItem.type">
                        <div class="filterTypeItem" :class="{'active' : filterTypeItem.active,
                        opened : filterTypeItem.openStatus}" @click="filterTypeItem.active = true; openFilterDrawer(filterTypeItem);
                         filterTypeItem.openStatus = true">
                            {{filterTypeItem.title}}
                        </div>
                    </div>
                </div>
            </div>

            <div class="jobRequestList hiddenScrollbar" style="overflow: auto">
                <div class="jobRequestItem roundBorder4" style="background: #F5F5F5;" v-for="(dataItem, i) in dataList"
                     :key="i">
                    <div class="padding12">
                        <div class="clearfix font14r">
                            <div style="display: flex;width: 100%;justify-content: space-between;margin-bottom: 8px;">
                                <div style="display: flex;">
                                    <img style="width: 36px;height: 36px;border-radius: 50%;margin-left: 8px;"
                                         :src="dataItem ? dataItem.headImg : ''"
                                         :alt="dataItem ? dataItem.headImg : ''">
                                    <div class="applicantName color333">{{ dataItem ? cutString(dataItem.name, 9) : '1' }}</div>
                                </div>
                                <div class="orange educations">
                                    <span>{{ dataItem ? (dataItem.educationBackground || "暂无学历") : "暂无学历" }}</span>
                                    <span>&nbsp;|&nbsp;{{ dataItem ? (dataItem.educationCertificate || "暂无证书") : "暂无证书" }}</span>
                                </div>
                            </div>
                            <div class="fl bold">
                                <p>意向岗位：{{ dataItem ? formatJobName(dataItem.jobName) : '' }}</p>
                                <p>期望薪资：
                                    <span>{{ dataItem ? dataItem.salaryMin || "面议" : "面议" }}
                                        <span v-if="dataItem.salaryMin">千</span>
                                    </span>
                                    <span v-if="dataItem.salaryMax && dataItem.salaryMin">
                                        &nbsp;-&nbsp;{{ dataItem ? dataItem.salaryMax || "面议" : "面议" }}
                                        <span v-if="dataItem.salaryMax">千</span>
                                    </span>
                                    <span v-if="dataItem.salaryMin && dataItem.salaryMax">/月</span>
                                </p>
                            </div>
                        </div>
                        <div class="clearfix font12r" style="color: #8994A9">
                            <div class="fr">
                                <button class="button redButton font16r" style="padding: 0;
                                    width: 110px; height: 28px; line-height: 28px;"
                                    @click="viewDetail(dataItem)">联系
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="alignCenter colorCCC bold" v-show="dataList.length < 1">
                    <img src="notice/no_content.png" width="206" height="143" alt="无内容" style="margin-top: 60px;"/>
                </div>
            </div>

        </div>

        <areaSelectorDrawer ref="areaSelectorDrawer" @change="changeArea" />
        <resumeSortSelectorDrawer ref="resumeSortSelectorDrawer" @change="changeSort" />
        <jobScreeningDrawer ref="jobScreeningDrawer" @change="changeJob" />
        <salaryPackageDrawer ref="salaryPackageDrawer" @change="changeAsk" />

        <jobRequestDetailDrawer ref="detailDrawer" title=""/>
    </div>
</template>

<script>
import appHelper from "@util/appHelper";
import generalCmpPart from '@comp/part/generalCmpPart';

// config
import appConfig from '@/appConfig';

// modules
import jobRequestDetailDrawer from './jobRequestDetailDrawer';
import areaSelectorDrawer from '@comp/drawer/areaSelectorDrawer';
import jobScreeningDrawer from '@comp/humanResources/drawer/jobScreeningDrawer';
import salaryPackageDrawer from '@comp/humanResources/drawer/salaryPackageDrawer';
import resumeSortSelectorDrawer from '@comp/humanResources/drawer/resumeSortSelectorDrawer';

// style
import '@/components/humanResources/filterTypeItem.scss';

// util
import numberHelper from "@/util/numberHelper";
import stringHelper from "@/util/stringHelper";
import arrayHelper  from "@/util/arrayHelper";

const config = {
    apiConfig: {
        list: {
            url: appConfig.apiBaseUrl + 'portal/recruit/seeker/search',
            params : {},
            dataPath: 'data.records',
            totalPagePath: 'data.pages',
            dataColumnMapping: {
                // userName : 'name''
            }
        }
    },
    demoJobNameList: [ '幼儿教师', '小班辅导员', '教务老师'],
    demoEucationBackgroundList : [ '大专', '本科', '中专', '高中', '初中'],
    demoEducationCertificateList : [ '幼儿教师资格证', '小学教师资格证', '初中教师资格证', '高中教师资格证', '大学教师资格证'],

};

export default {
    extends: generalCmpPart,
    components: {
        jobRequestDetailDrawer,
        areaSelectorDrawer,
        jobScreeningDrawer,
        resumeSortSelectorDrawer,
        salaryPackageDrawer
    },
    data() {
        return {
            apiConfig: config.apiConfig,
            enableDataList: true,
            autoLoadDataList: appConfig.mode != 'demo',

            filterTypeList: [{
                type: 'area',
                title: '区域',
                active: false,
                openStatus: false
            }, {
                type: 'sort',
                title: '排序',
                active: false,
                openStatus: false
            }, {
                type: 'job',
                title: '职位',
                active: false,
                openStatus: false
            }, {
                type: 'ask',
                title: '要求',
                active: false,
                openStatus: false
            },],
        }
    },
    methods: {
        viewDetail(dataItem) {
            this.$refs.detailDrawer.loadDataItem(dataItem.id);
            this.$refs.detailDrawer.open();
        },
        onRemoveDataItem() {
            this.reloadDataList();
        },
        formatJobName(jobNames) {
            if (jobNames.length) {
                return jobNames.join("、");
            }
            return "无期望岗位";
        },
        cutString(str, len) {
            //length属性读出来的汉字长度为1
            if (str) {
                if (str.length * 2 <= len) {
                    return str;
                }
                var strlen = 0;
                var s = "";
                for (var i = 0; i < str.length; i++) {
                    s = s + str.charAt(i);
                    if (str.charCodeAt(i) > 128) {
                        strlen = strlen + 2;
                        if (strlen >= len) {
                            return s.substring(0, s.length - 1) + "...";
                        }
                    } else {
                        strlen = strlen + 1;
                        if (strlen >= len) {
                            return s.substring(0, s.length - 2) + "...";
                        }
                    }
                }
                return s;
            }
            return str
        },
        openFilterDrawer (filterTypeItem) {
            switch (filterTypeItem.type) {
                case 'area':
                    this.$refs.areaSelectorDrawer.open();
                    break;
                case 'sort':
                    this.$refs.resumeSortSelectorDrawer.open();
                    break;
                case 'job':
                    this.$refs.jobScreeningDrawer.open();
                    break;
                case 'ask':
                    this.$refs.salaryPackageDrawer.open();
                    break;
            }
        },
        changeArea (data) {
            let province = data.province;
            let city = data.city;
            let areaList = data.areaList;
            this.filterTypeList[0].active = province ? true : false;
            this.apiConfig.list.params.province = province;
            this.apiConfig.list.params.city = city;
            this.apiConfig.list.params.areas = areaList.join(',');
            this.reloadDataList();
        },
        changeSort (data) {
            let sortType = data.sortType;
            this.filterTypeList[1].active = sortType ? true : false;
            this.apiConfig.list.params.sortType = sortType;
            this.reloadDataList();
        },
        changeJob (data) {
            this.apiConfig.list.params.jobNames = data;
            this.filterTypeList[2].active = data ? true : false;
            this.reloadDataList();
        },
        changeAsk (data) {
            this.filterTypeList[3].active = data ? true : false;
            if (!data) {
                data = {};
            }
            this.apiConfig.list.params.salaryMin = data.salaryMin;
            this.apiConfig.list.params.salaryMax = data.salaryMax;
            this.reloadDataList();
        }
    }
}
</script>

<style lang="scss" scoped>
.orange {
    color: #ffa724;
}

.jobRequestItem {
    margin-bottom: 12px;
}

.applicantName {
    width: fit-content;
    height: 22px;
    font-weight: 500;
    line-height: 18px;
    margin-left: 17px;
    margin-top: 6px;
}

.educations {
    margin-top: 6px;
    font-size: 14px;
    font-weight: 400;
    line-height: 18px;
}
</style>
